import React from 'react';
import './Modal.css'; // Asegúrate de ajustar la ruta según la ubicación de tu archivo

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="sancion-modal-overlay" onClick={handleOverlayClick}>
      <div className="sancion-modal-content">
        <button className="sancion-modal-close-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
